import { h } from "preact";

const OPTIONS = [100, 200, 300, 400, 500, 1000, 2000, 0];

/**
 * Выбор тиража: селект + ручной ввод при значении 0.
 *
 * Пропсы:
 *   quantity         — выбранное значение (0 = «Другой»)
 *   quantity_manual  — значение ручного ввода
 *   min_quantity     — минимально допустимое
 *   onchange         — колбэк (value) => void для селекта
 *   onmanualchange   — колбэк (value) => void для ручного ввода
 */
export function QuantitySelector({
  quantity,
  quantity_manual,
  min_quantity,
  onchange,
  onmanualchange,
}) {
  function handleSelect(e) {
    onchange(parseInt(e.target.value, 10));
  }

  function handleManualInput(e) {
    const v = parseInt(e.target.value, 10) || 0;
    if (v >= min_quantity) onmanualchange(v);
  }

  function handleManualBlur(e) {
    const v = parseInt(e.target.value, 10) || 0;
    onmanualchange(v >= min_quantity ? v : min_quantity);
  }

  return h("fieldset", { class: "quantity-selector" },
    h("select", {
      class: "quantity-selector__select",
      onchange: handleSelect,
    },
      OPTIONS.map((value) =>
        h("option", {
          key: value,
          value,
          selected: value === quantity,
        }, value || "Другой:")
      )
    ),

    quantity === 0 && h("input", {
      type: "text",
      value: quantity_manual,
      placeholder: "Введите количество",
      class: "quantity-selector__manual",
      oninput: handleManualInput,
      onblur: handleManualBlur,
    })
  );
}
